import { combineReducers } from 'redux'
import { emptyArray } from 'utils'

import {
  FETCH_DISTRICT_RESULTS,
  FETCH_DISTRICT_RESULTS_ERROR,
  FETCH_DISTRICT_RESULTS_SUCCESS,
  FETCH_REGION_RESULTS,
  FETCH_REGION_RESULTS_ERROR,
  FETCH_REGION_RESULTS_SUCCESS,
} from './constants'

const isFetchingDistrictResults = (state = false, { type }) => {
  switch (type) {
    case FETCH_DISTRICT_RESULTS:
      return true
    case FETCH_DISTRICT_RESULTS_ERROR:
    case FETCH_DISTRICT_RESULTS_SUCCESS:
      return false
    default:
      return state
  }
}

const isFetchingRegionResults = (state = false, { type }) => {
  switch (type) {
    case FETCH_REGION_RESULTS:
      return true
    case FETCH_REGION_RESULTS_ERROR:
    case FETCH_REGION_RESULTS_SUCCESS:
      return false
    default:
      return state
  }
}

const districtResults = (state = emptyArray, { payload, type }) => {
  switch (type) {
    case FETCH_DISTRICT_RESULTS_ERROR:
      return emptyArray
    case FETCH_DISTRICT_RESULTS_SUCCESS:
      return payload
    default:
      return state
  }
}

const regionResults = (state = emptyArray, { payload, type }) => {
  switch (type) {
    case FETCH_REGION_RESULTS_ERROR:
      return emptyArray
    case FETCH_REGION_RESULTS_SUCCESS:
      return payload
    default:
      return state
  }
}

export default combineReducers({
  isFetchingDistrictResults,
  isFetchingRegionResults,
  districtResults,
  regionResults,
})
